import React from 'react';
import PicklistTableBase from '../PicklistTableBase';
import { usePicklistDetailsSelector, usePicklistPermissions } from 'hooks/Picklist';
import { assetsTableConfig } from '../../../helpers';
import { DrCodeCellContent } from '../Cells';

export function PicklistAssets(props) {
  const {
    assets,
    filter,
    criteria: { picklistAssetStatuses }
  } = usePicklistDetailsSelector();
  const permissions = usePicklistPermissions();
  const { canEditDrCode } = permissions;

  return (
    <PicklistTableBase
      {...props}
      tableData={assets}
      tableConfig={assetsTableConfig}
      filter={filter}
      assetStatuses={picklistAssetStatuses}
      permissions={permissions}
      addDataLabel="Add assets to the picklist."
      renderNameCell={(row) => (
        <DrCodeCellContent row={row} onEdit={props.onEditDrCode} isEditable={canEditDrCode(row)} />
      )}
    />
  );
}
